import { z } from 'zod';

export const getUserPreferencesSchema = z.array(
  z.object({
    id: z.string(),
    designation: z.string(),
    preferenceContent: z.string().nullish(),
    userID: z.string(),
    preferenceType: z.string(),
    createUserID: z.string().nullish(),
    isDefault: z.boolean(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    deleted: z.boolean(),
  })
);

export type GetUserPreferencesResponse = z.infer<typeof getUserPreferencesSchema>;
